import Vue from "vue";
import VueI18n from 'vue-i18n'
import VueCookies from "vue-cookies"
import zh from "./lang/zh"
import en from "./lang/en"

Vue.use(VueI18n);

let language = VueCookies.get("accept-language");
// let language = window.navigator.language;
language = (language === 'zh-Hans-US' ? 'zh-CN' : language);

const i18n = new VueI18n({
    locale: language || 'zh-CN',    // 语言标识
    messages: {
        'zh-CN': zh,   // 中文语言包
        'en-US': en    // 英文语言包
    }
});

export default i18n
